import { Injectable } from '@angular/core';
import { CommonService } from 'tnx-shared';
import { RuleService } from './rule.service';

export const DEFAULT_INTERVAL_CHECK_IN_HOUR = 1;

export interface IRuleTrackingParam {
    buildCode?: Function;
}

export enum EnumRuleType {
    ClientFaviconExisted = 0
}

export class RuleFaviconExistedParam implements IRuleTrackingParam {
    buildCode?: Function = () => {
        return `${EnumRuleType[EnumRuleType.ClientFaviconExisted]}`;
    }

    constructor(init?: RuleFaviconExistedParam) {
        for (const key in init) {
            this[key] = init[key];
        }
    }
}

export class BasicRule {
    code?: string;
    author?= 'UNKNOWN';
    title?: string;
    description?: string;

    constructor(init?: BasicRule) {
        for (const key in init) {
            this[key] = init[key];
        }
    }
}

export class CheckResult {
    ruleRassed: boolean;
    executionTime?: number;
    exception?: string;

    constructor(init?: CheckResult) {
        for (const key in init) {
            this[key] = init[key];
        }
    }

    static withPassed(exception = ''): CheckResult {
        return new CheckResult({
            ruleRassed: true,
            exception: exception
        })
    }

    static withNotPassed(exception = ''): CheckResult {
        return new CheckResult({
            ruleRassed: false,
            exception: exception
        })
    }
}

@Injectable()
export class RuleBuilderService {
    insertRule = [];
    deleteRule = [];

    constructor(
        private _ruleService: RuleService,
        private _commonService: CommonService
    ) {

    }

    addRule(ruleType: EnumRuleType, param: IRuleTrackingParam, basicRule: BasicRule = null, isDeleted: boolean = false) {
        if (!basicRule) {
            basicRule = new BasicRule();
        }
        const rule = {
            code: basicRule.code ?
                basicRule.code :
                (param.buildCode ? param.buildCode() : `${EnumRuleType[ruleType]}`),
            ruleType: EnumRuleType[ruleType],
            isApi: false,
            ruleParams: JSON.stringify(param),
            author: basicRule.author,
            description: basicRule.description,
            intervalCheckInMinutes: DEFAULT_INTERVAL_CHECK_IN_HOUR,
            nextCheckedAt: this._commonService.addHours(new Date(), DEFAULT_INTERVAL_CHECK_IN_HOUR),
            title: basicRule.title
        };

        if (!isDeleted) {
            this.insertRule.push(rule);
        } else {
            this.deleteRule.push(rule);
        }

        return this;
    }

    commit() {
        if (this.insertRule.length == 0 && this.deleteRule.length == 0) {
            return;
        }
        this._ruleService.commit({ insert: this.insertRule, delete: this.deleteRule }).then(rs => {
            console.log('commit success', rs);
            this.insertRule.length = 0;
            this.deleteRule.length = 0;
        }).catch(err => {
            console.log('commit error', err);
            this.insertRule.length = 0;
            this.deleteRule.length = 0;
        });
    }
}
